import { INTEGRATION_OPEN_SIDESHEET } from '../constants'

export function openSideSheet() {
    return async dispatch => {
        dispatch({
            type: INTEGRATION_OPEN_SIDESHEET
        })
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_OPEN_SIDESHEET:
            return {
                ...state,
                isSideSheetOpen: true,
            }

        default:
            return state
    }
}

